import { module } from 'stereomodularjs';
import svgIco from '../components/svgIco.vue'
import UsedCarPayments from '../components/UsedCarPayments.vue'
import Note from '../components/Note.vue'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let hasFinance = true;
        let data = JSON.parse(this.el.dataset.payments);
        if (!data) {
            hasFinance = false;
            data = {price: parseInt(this.el.dataset.price,10)};
        }
        data.rebate = parseInt(this.el.dataset.rebate,10)
        data.spriteURL = this.el.dataset.sprite
        data.select = 'weekly'
        data.hasFinance = hasFinance
        data.type = hasFinance ? 'finance' : 'cash';
        data.includeTaxes = false
        data.exchange = ''
        data.initialCash = ''
        data.expanded = hasFinance ? false : true;
        const app = createApp({
            template: '<UsedCarPayments />',
            components: { svgIco, UsedCarPayments, Note },
            data() {
                return data;
            },
            methods: {
                
            },
            computed: {
               

            },
            watch: {
                
            },
            mounted() { },
        })
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.config.globalProperties.pct = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' %';
        }
        app.config.globalProperties.nb = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        app.component("svgIco", svgIco)
        app.component("Note", Note)

        app.mount(self.el)
    }
}
